module.exports = __webpack_public_path__ + "img/gb.c3c8d650.png";